import { PropsWithChildren, ReactElement } from 'react';
import ScrollFadeContainer from '__components/Kizen/ScrollFadeContainer';
import { useScrollBar } from './useScrollBar';
import { StyledDetachedScrollBar } from './styles';

type Axis = 'x' | 'y';

type ScrollbarProps = {
  axis: Axis;
  topOffset?: number;
  zedIndex?: number;
  setInteracting?: (interacting: boolean) => void;
};

const ScrollBar = ({
  axis,
  topOffset,
  zedIndex,
  setInteracting,
}: ScrollbarProps) => {
  const [innerSize, outerProps] = useScrollBar(axis, setInteracting);
  return (
    <StyledDetachedScrollBar
      direction={axis === 'x' ? 'horizontal' : 'vertical'}
      size={innerSize}
      topOffset={topOffset}
      zedIndex={zedIndex}
      {...outerProps}
    />
  );
};

type FlowScrollContainerProps = {
  top?: boolean;
  bottom?: boolean;
  left?: boolean;
  right?: boolean;
  gradient?: ReactElement;
  setInteracting?: (interacting: boolean) => void;
};

export const FlowScrollContainer = ({
  children,
  setInteracting,
  top,
  bottom,
  left,
  right,
  gradient,
}: PropsWithChildren<FlowScrollContainerProps>) => {
  return (
    <ScrollFadeContainer
      className="FlowContainer"
      top={top}
      bottom={bottom}
      left={left}
      right={right}
      gradient={gradient}
    >
      {children}
      <ScrollBar
        axis="x"
        setInteracting={setInteracting}
        zedIndex={right ? 6 : 4}
      />
      <ScrollBar
        axis="y"
        setInteracting={setInteracting}
        zedIndex={bottom ? 6 : 5}
      />
    </ScrollFadeContainer>
  );
};
